import moment from 'moment';
import { isValidNumber } from 'libphonenumber-js';
import i18n from '../internationalization/i18n';

const trans = (id, params = {}) => i18n.t(`VALIDATION.${id}`, params);

export const renderError = (error) => {
  if (!error) {
    return null;
  }

  if (typeof error === 'string') {
    return trans(error);
  }

  if (Array.isArray(error)) {
    const [message, params = {}] = error;

    return trans(message, params);
  }

  return null;
};

export default {
  required(value) {
    const trimmed = String(value).trim();

    return value && (trimmed.length > 0)
      ? undefined
      : 'required';
  },

  email(value) {
    if (!value) {
      return undefined;
    }

    return (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value))
      ? 'email'
      : undefined;
  },

  maxLength(max) {
    return function maxLength(value) {
      return value && value.length > max
        ? ['maxLength', { max }]
        : undefined;
    };
  },

  minLength(min) {
    return function minLength(value) {
      return value && value.length < min
        ? ['minLength', { min }]
        : undefined;
    };
  },

  minNumberOptions(min, name) {
    return function minLength(value) {
      return value && value.length < min
        ? ['minNumberOptions', { min, name }]
        : undefined;
    };
  },

  number(value) {
    return value && isNaN(Number(value))
      ? 'number'
      : undefined;
  },

  photoNumberLength(value) {
    const size = 9;

    return value && value.length > size
      ? ['photoNumberLength', { size }]
      : undefined;
  },

  alphaNumeric(value) {
    return value && /[^a-zA-Z0-9 ]/i.test(value)
      ? 'alphaNumeric'
      : undefined;
  },

  alphabetic(value) {
    return value && /[^a-zA-Z ]/i.test(value)
      ? 'alphabetic'
      : undefined;
  },

  dateFormat(format) {
    return function dateFormat(value) {
      return value && !moment(value, format, true).isValid()
        ? ['dateFormat', { format }]
        : undefined;
    };
  },

  // from gist https://gist.github.com/dperini/729294
  url(value) {
    return value && !/^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value)
      ? 'url'
      : undefined;
  },

  phoneNumber(value) {
    return value && !isValidNumber(value)
      ? 'phoneNumber'
      : undefined;
  },
};



// WEBPACK FOOTER //
// ./src/tools/validation.js